export const pages = {
	'linkOutHU': { id: 'linkOutHU', page: 'text', getter: () => import(/* webpackChunkName: 'text' */ 'components/bolt/text/text') }
};
export const sections = [

];
